import { Linking } from "react-native";
import fetchTopStack from "@utils/getDetailsTopOfStack";
import { QueryParams } from "./parseSearchParams";
import NavigationService from "./NavigationService";

export default (link = "", linkType = "", extras = {}) => {
  if (link && linkType === "INTERNAL") {
    const searchParams = new QueryParams(link);
    if (searchParams.has("app_screen")) {
      const { name: topName, params: topParams } = fetchTopStack();
      const screenName = searchParams.get("app_screen");
      const otherParams = searchParams.params;
      delete otherParams.app_screen;
      const params = { ...otherParams, ...extras };
      if (
        JSON.stringify({ name: topName, params: topParams }) ===
        JSON.stringify({ name: screenName, params })
      ) {
        return;
      }

      NavigationService.push(screenName, {
        ...otherParams,
        ...extras,
      });
    }
  } else if (link && linkType === "EXTERNAL") {
    Linking.openURL(link);
  }
};
